/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */

import vasActivationModalTemplate from '../SavedWithSuccessModal.html'; 

class payWithPaypalController {

  /* @ngInject */

  constructor($sce, $q, $location, $timeout,
              MerchantVasService, $rootScope, ModalFactory,
              TermsService, NewTokenService, StorageService, CatalogService) {
    const that = this;
    that.currentVasTypeId = MerchantVasService.getVasesTypes()['PAY-WITH-PAYPAL'];
    that.currentWalletId = NewTokenService.getMerchantWalletID();
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    let tinabaErrorList = StorageService.getLocalStorage('tinabaErrorList');
    if (tinabaErrorList) {
      that.errorCodeList = JSON.parse(tinabaErrorList);
    } else {
      that.errorCodeList = [];
    }
    that.currentState = 0
    that.regInfo
    that.errorMsg = undefined
    that.iconState =  '../../../img/paypal/1-big.png'

    that.getIconState = () => {
      return '../../../img/paypal/1-big.png'
    }

    that.register = () => {
      MerchantVasService.startRegistration($location.absUrl(), that.merchantProfile.business.id, that.isSuperAdmin)
        .then(
          (response) => {
            window.open(response.data._links.action_url.href,'popup','width=1000,height=700,'); return false;
          },
          (error) => {
            console.log(error)
            var errorCode = that.errorCodeList.find(el => {return el.code == error.data.context.code})
            if(errorCode){
              that.errorMsg = that.errorMsg = $sce.trustAsHtml(errorCode.message)
            }else{
              that.errorMsg = that.errorMsg = $sce.trustAsHtml(error.data.context.message)
            }
          }
        );
    }

    that.completeReg = () => {
      getRegInfo(that.merchantProfile.business.id)
      window.open(that.regInfo._links.action_url.href,'popup','width=1000,height=700,'); return false;
    }

    const getRegInfo = (businessId) => {
        getPaypalRegistrationInfo(businessId)
        .then(
          (response) => {
            console.log(response)
            that.regInfo = response.data
            that.loading = false
            var errorCode = that.errorCodeList.find(el => {return el.code == response.data.errorCode})
            if(errorCode){
              this.currentState = 1;
              that.errorMsg = $sce.trustAsHtml(errorCode.message)
            }
            
            if(that.regInfo.errorLevel != "ERROR" && that.regInfo.status == "ENABLED"){ 
              if(!that.regInfo.cardPaymentsReceivable && that.regInfo.paymentsReceivable ){
                that.currentState = 2
              } else if(that.regInfo.cardPaymentsReceivable && that.regInfo.paymentsReceivable){
                that.currentState = 3
              }
            }
          },
          (error) => {
            that.loading = false
            alert('error retrieving the vas!');
          }
        );
    }

    const getPaypalRegistrationInfo = (businessId) => {
      if(that.isSuperAdmin){
        return MerchantVasService.getPaypalRegistrationInfoByAdmin(businessId)
      }else{
        return MerchantVasService.getPaypalRegistrationInfo()
      }
    }

    that.enablePaypal = (toAction) => {
      const type = MerchantVasService.getVasesTypes()['PAY-WITH-PAYPAL'];
      MerchantVasService.enableVasForMe(type).then(
        () => {
          if(toAction){
            getPaypalVas()
          }
        }
      )
  };

  const getPaypalVas = () => {
    MerchantVasService.getVasByType(that.currentVasTypeId, that.merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
            if(that.currentVas.status != "SUBSCRIBED"){
              that.enablePaypal(false)
            }
            if(that.currentVas.configuration.externalStatus != "UNREGISTERED"){
              this.currentState = 1
              getRegInfo(that.merchantProfile.business.id)
            }else{
              this.currentState = 0
              that.loading = false
            }
          },
          (error) => {
            if(error.status == 404){
              that.enablePaypal(true)
            }else{
              alert("Error retrieving vas")
            }
          }
      );
  }

  that.enableService = () => {
    MerchantVasService.configureVas( that.currentVas.configuration, that.currentVas.id).then((ok) => {
      that.currentVas.configuration = ok.data;
      that.showVasConfigurationSuccess();
    });
  }
  
    const init = () => {
      that.merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      that.loading = true
      getPaypalVas()
    };

    that.showVasConfigurationSuccess = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };
  
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: vasActivationModalTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });
  
      modal.activate();
    };

    that.$onInit = init;
  }

}

export default payWithPaypalController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/payWithPaypal/payWithPaypal.controller.js
 **/